import React from 'react';
import SingleCancellationPolicy from './single-cancellation-policy.jsx';
import SyncSectionCheckbox from '../sync-section-checkbox';
import SeasonalSections from '../../../generic-components/seasonal-sections/seasonal-sections';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import R, { concat, curry, pathOr } from 'ramda';

const CancellationPolicies =
({
    contractingPeriod,
    onTextFieldChangeWithKeyPath,
    existingSeasons,
    productType,
    contractId,
    productId,
    onRequestClose,
    saveProductInfoChanges,
    saving,
    data,
}) => {
  const shouldDisable = (() => {
    return !(data.cancellations.length && data.cancellations.every(obj => {
      if (obj.conditions === 'Same as location cancellation policy') return true;
      return !R.isNil(obj.cancelNum) && obj.cancelHoursDays && obj.conditions;
    }));
  })();
  const contentActions = { productType, onTextFieldChange: (index, key, value) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'cancellations', index, key], value }) };
  const onFieldChange = curry((extraPaths, value) => onTextFieldChangeWithKeyPath({ keyPath: concat(['data', 'cancellations'], extraPaths), value }));
  return (
    <div>
      <div style={{ margin: '8px 0 0 24px' }}>Note: Cancellation Policies that apply to all room types/product can be added in the Policies & Notes page.</div>
      <SeasonalSections
        name={'cancellation policies'}
        seasons={existingSeasons}
        contractingPeriod={contractingPeriod}
        varyBySeason={data.varyBySeason}
        useSeasons={data.varyBySeason}
        contentsData={data.cancellations}
        emptyInitialContent={{ conditions: '' }}
        onFieldChange={onFieldChange}
        contentActions={contentActions}
        showError={data.showError}
        ContentNode={SingleCancellationPolicy}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 8px 0px 12px', marginTop: data.cancellations && data.cancellations.length ? '' : '150px' }}>
        <SyncSectionCheckbox
          sectionInEdit="cancellations"
          labelStyle={{ width: '70%' }}
          style={{ width: '55%', top: '6px' }}
        />
        <div>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            labelStyle={{ fontWeight: '600' }}
            onClick={() => {
              if (shouldDisable) {
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'showError'], value: true });
              }
              saveProductInfoChanges({
                contractId,
                productId,
                data,
                updateType: 'SAVE_SEASONAL_CANCELLATION_POLICIES',
              });
            }}
            secondary
          />
        </div>
      </div>
    </div>
  );
};

CancellationPolicies.propTypes = {
};

export default CancellationPolicies;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/seasonal-cancellation-policy/cancellation-policies.jsx